var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import Fuse from 'fuse.js';
export default function fuzzyFilter(input, term, options) {
    // fuse.js defaults "shouldSort" option to true, which is counter intuitive and contradicts their usage example
    // fix it by setting shouldSort to false by default
    var normalizedOptions = __assign({ shouldSort: false }, options);
    term = term.trim();
    if (!term) {
        return input;
    }
    return new Fuse(input, normalizedOptions).search(term);
}
//# sourceMappingURL=fuzzyFilter.js.map